<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
            <div>
                <v-row justify="center" >
                    <v-col class="text-left col-md-9">
                        <div class="font-weight-bold body-1">
                            Nuevo Curso
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="9">
                        <v-form ref="form" @submit.prevent="save">
                            <comp-form ref="DepForm" :values="form" @save="save" :serverErrors="serverErrors" :stepIn="step" :stepClasses="stepClasses" @tabChanged="(val) => this.test(val)" :edit="false"></comp-form>
                        </v-form>
                    </v-col>
                    
                </v-row>

            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="9" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <secondary-button :props="saveDraftBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../../helpers/Utils';
import DepForm from "./Form.vue";
import Object2Form from '../../../helpers/Object2Form.js';
export default {
    components: {
        'comp-form': DepForm,
    },
	data(){
		return {
            step: '1',
           
            stepClasses: {st1: '', st2: '', st3: '', st4: ''},
            loading: false,
            serverErrors: {},
            form: {
                title: "",
                brief_description:"",
                duration: "",
                summary: "",
                description: "",
                what_you_will_learn: "",
                sections:[
                    {
                        title: '',
                        lessons: [
                            {
                                title:'',
                                type: 'LECCIÓN',
                                has_content:false,
                            }
                        ]
                    }
                ],
                list_companies:[],
                draft:0,
                image_file: []
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Courses",	
                block:false,
                click: () => {}
            },
            saveDraftBtnData: {
                text: "Guardar como borrador",
                icon: "mdi-content-save-outline",
                to: "",	
                block:false,
                click: () => {this.saveDraft()},
            },
            saveBtnData: {
                text: "Siguiente",
                icon: "mdi-content-save-outline",	
                click: () => {this.save(false)},
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
    },
	methods: {
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate()
		},
        test(val){
            console.log(val);
            this.step = val+'';
            console.log(this.step);

            this.saveBtnData.text = 'Guardar';
            if(this.step == '1'){
                this.saveBtnData.text = 'Siguiente';
            }
        },

        save(draftMode = false){
            if(this.step == '1' && draftMode == false){
                this.test(Number(2))
                return;
            }
            
            if(this.validate()){

                 if(!draftMode){
                    this.form.draft = 0;
                }
                this.setStateLoading(draftMode, true);
                this.$store.state.loading = true;
                console.log(this.form);
                
                let form = this.processRequest(this.form);
                
                this.$api.course.storeCourse(form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha creado correctamente`);
                        this.$router.push({name: 'Courses'});
                    })
                    .catch((error) => {
                        //console.log(error.response)
                        var errors = []
                        switch(error.response.status){
                            case 400: 
                                //console.log(99, error.response);
                                if(("message" in error.response.data)){
                                    Object.keys(error.response.data.message).forEach((x) => {
                                        //console.log(x);
                                        this.serverErrors = error.response.data.message;
                                        error.response.data.message[x].forEach((y) => {
                                            this.serverErrors[x] = Utils.deleteWord(x,y);
                                            errors.push(Utils.deleteWord(x,y))
                                        })
                                    });
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }

                       
                    })
                    .finally(() => {
                       this.setStateLoading(draftMode, false);
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                this.setStateLoading(draftMode, false);
                this.$store.state.loading = false;
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },

        setStateLoading(draftMode, value){
            if(!draftMode){
                this.saveBtnData.loading = value;
            }else{
                this.saveDraftBtnData.loading = value;
            }
        },

        saveDraft(){
            this.form.draft = 1;
            this.save(true);
        },


        processRequest(request){
            let data = JSON.parse(JSON.stringify(request));

            data.draft = data.draft.toString();

            data.image_file = request.image_file;

            data.list_companies = [];

            request.list_companies.forEach(c => {
                data.list_companies.push({id: c.value, name:c.text})
            });

            data.description = data.brief_description;

            return Object2Form.objectToFormData(data, '', []);
        }
    },
}
</script>

<style>

</style>